import SalesContainer from '@components/containers/sales';
import AppLayout from '@layouts/AppLayout';
import type { FC } from 'react';

const Sales: FC = () => {
    return (
        <AppLayout>
            <SalesContainer />
        </AppLayout>
    );
};

export default Sales;
